/**
 * Owner: Masa Bayu
 * File: design-border.ts
 * Date:Time: 2026-09-13 18:04
 * Description: 22A border/divider semantics (not CSS border styles).
 */
export const QX_DESIGN_BORDER_ROLES = ['none', 'subtle', 'strong', 'focus', 'divider'];
export const QX_DESIGN_BORDER_STYLES = ['none', 'solid', 'dashed', 'dotted'];
export function isQXDesignBorderRole(value) {
    return typeof value === 'string' && QX_DESIGN_BORDER_ROLES.includes(value);
}
export function isQXDesignBorderStyle(value) {
    return (typeof value === 'string' && QX_DESIGN_BORDER_STYLES.includes(value));
}
export function createQXDesignBorderToken(options) {
    if (!isQXDesignBorderRole(options.role)) {
        throw new Error(`Invalid design border role: ${String(options.role)}`);
    }
    if (typeof options.widthStep !== 'number' ||
        !Number.isFinite(options.widthStep) ||
        options.widthStep < 0) {
        throw new Error('Design border widthStep must be a finite number >= 0');
    }
    if (!isQXDesignBorderStyle(options.style)) {
        throw new Error(`Invalid design border style: ${String(options.style)}`);
    }
    if (typeof options.colorRole !== 'string' ||
        options.colorRole.trim().length === 0 ||
        /\s/.test(options.colorRole)) {
        throw new Error('Design border colorRole must be a non-empty id without whitespace');
    }
    return Object.freeze({
        role: options.role,
        widthStep: options.widthStep === 0 ? 0 : options.widthStep,
        style: options.style,
        colorRole: options.colorRole.trim(),
    });
}
export function createQXDesignBorderSystem(borders) {
    const list = [...borders];
    const seen = new Set();
    for (const border of list) {
        if (!isQXDesignBorderRole(border.role)) {
            throw new Error(`Invalid design border role: ${String(border.role)}`);
        }
        if (seen.has(border.role)) {
            throw new Error(`Duplicate design border role: ${border.role}`);
        }
        seen.add(border.role);
    }
    return Object.freeze({ borders: Object.freeze(list) });
}
export function isQXDesignBorderSystem(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        return false;
    }
    return Array.isArray(value.borders);
}
export function validateQXDesignBorderSystem(value) {
    if (!isQXDesignBorderSystem(value)) {
        throw new Error('Invalid design border system');
    }
    createQXDesignBorderSystem(value.borders);
}
//# sourceMappingURL=design-border.js.map